import { format, parse, isValid } from 'date-fns';

export const apiToDateObject = (mmddyyyyDate) => {
    if (!mmddyyyyDate || typeof mmddyyyyDate !== 'string') return null;
    let parsedDate = parse(mmddyyyyDate, 'MM/dd/yyyy', new Date());
    if (!isValid(parsedDate)) parsedDate = parse(mmddyyyyDate, 'yyyy-MM-dd', new Date());
    return isValid(parsedDate) ? parsedDate : null;
};

export const dateObjectToApiFormat = (dateObj) => {
    if (!dateObj || !isValid(dateObj)) return '';
    return format(dateObj, 'MM/dd/yyyy');
};